import React from 'react'
import { NavLink } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'

const MEMBER_LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/me/responses', label: 'My responses' },
]

const ADMIN_LINKS = [
  { to: '/initiatives', label: 'Initiatives' },
  { to: '/catalog', label: 'Catalog' },
  { to: '/knowledge', label: 'Knowledge' },
  { to: '/upload', label: 'Upload' },
]

// Phase 2 navigation. Members see Home + My responses. Admins additionally
// see Initiatives / Catalog / Knowledge / Upload. The admin queue editor is
// reachable from each Initiative detail page rather than the sidebar so
// admins don't have to pick the initiative twice.
export default function Navigation() {
  const isAdmin = useAuthStore((s) => s.isAdmin())

  return (
    <nav className="flex flex-col gap-1">
      {MEMBER_LINKS.map(({ to, label, end }) => (
        <NavItem key={to} to={to} label={label} end={end} />
      ))}

      {isAdmin && (
        <>
          <div className="mt-4 mb-1 px-3 text-xs uppercase tracking-wide text-slate-400">Admin</div>
          {ADMIN_LINKS.map(({ to, label }) => (
            <NavItem key={to} to={to} label={label} />
          ))}
        </>
      )}
    </nav>
  )
}

function NavItem({ to, label, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        [
          'rounded-md px-3 py-2 text-sm font-medium transition-colors',
          isActive
            ? 'bg-accent-50 text-accent-700'
            : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900',
        ].join(' ')
      }
    >
      {label}
    </NavLink>
  )
}
